export enum GenreType {
  MALE = 'male',
  FEMALE = 'female'
}

export const GenreDB = [
  { label: 'genre.male', value: GenreType.MALE },
  { label: 'genre.female', value: GenreType.FEMALE }
]
